const baseUrl = process.env.REACT_APP_BASE_API_URL;
const apiUrl = baseUrl+"/api/v2";

const endpoints = {
    baseUrl,
    getListedAnimeUrl: (listSlug: string, listedAnimeSlug: string) => {
        return `${apiUrl}/anime-lists/${listSlug}/listed-anime-items/${listedAnimeSlug}`;
    },
    animeLists: {
        base: `${apiUrl}/anime-lists`,
        select_options: `${apiUrl}/anime-lists/select-options`,
        xml: `${apiUrl}/anime-lists/xml`
    },
    users: {
        base: `${apiUrl}/users`,
        logged_in: `${apiUrl}/users/logged-in`,
        settings: `${apiUrl}/users/settings`
    },
    anime: {
        base: `${apiUrl}/anime-items`
    },
    studios: {
        base: `${apiUrl}/studios`
    },
    auth: {
        login_check: `${baseUrl}/login_check`,
        login_check_api: `${apiUrl}/login_check`,
        refresh: `${baseUrl}/token/refresh`,
        register: `${baseUrl}/register`
    },
    rankedLists: {
        base: `${apiUrl}/ranked-lists`
    }
}

export default endpoints;
